'use client'

import React from 'react'
import {isMobile} from 'react-device-detect'
import {css, useTheme} from '@emotion/react'

import {ProcessStatus} from '../../../../constants'
import delay from '../../../../utils/delay'
import useFullScreenFeature from '../../../../hooks/useFullScreenFeature'
import ProcessStatusInfo from '../../../../components/modules/ProcessStatusInfo'
import DataExportControl from '../../../../components/modules/DataExportControl'
import InputResultPanelLayout from '../../../../components/layouts/InputResultPanelLayout'
import TextEditor from '../../../../components/modules/TextEditor'
import JSONArea from './JSONArea'


export default function JSONViewer() {
  const theme = useTheme()
  const styles = {
    top: css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    `,

    inputControl: css`
      display: flex;
      justify-content: space-between;
    `,

    resultControl: css`
      display: flex;
      justify-content: flex-end;
    `,

    textArea: css`
      background: ${theme.palette.surface.light};
    `,

    bottomControlBar: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      height: 36px;
    `,
  }

  const [textInput, setTextInput] = React.useState('{}')
  const onTextInputChange = (textInput) => {
    setTextInput(textInput)
  }

  const [outputResult, setOutputResult] = React.useState({})

  const [processStatus, setProcessStatus] = React.useState(ProcessStatus.Idle)
  React.useEffect(() => {
    if (textInput) {
      let isSubscribed = true

      setProcessStatus(ProcessStatus.Processing)
      Promise.resolve()
        .then(() => delay(500))
        .then(() => {
          if (isJSONShowable(textInput)) {
            return JSON.parse(textInput)
          } else {
            throw new Error('invalid json object')
          }
        })
        .then(outputResult => {
          if (isSubscribed) {
            setOutputResult(outputResult)
            setProcessStatus(ProcessStatus.Success)
          }
        })
        .catch(e => {
          if (isSubscribed) {
            setOutputResult({})
            setProcessStatus(ProcessStatus.Failed)
          }
        })
      return () => isSubscribed = false
    } else {
      setOutputResult({})
      setProcessStatus(ProcessStatus.Idle)
    }
  }, [textInput])

  const [ResultFullScreenButton, ResultFullScreenContainer] = useFullScreenFeature()

  return (
    <InputResultPanelLayout
      inputContent={(
        <TextEditor
          id="text-input"
          lang={'json'}
          value={textInput}
          onChange={onTextInputChange}
          autoFocus={true}
          status={<ProcessStatusInfo id="process-status" processStatus={processStatus} enableProgressing/>}
        />
      )}

      resultControl={(
        !isMobile && <div css={styles.resultControl}>
          <ResultFullScreenButton/>
        </div>
      )}
      resultContent={(
        <ResultFullScreenContainer>
          <JSONArea data={outputResult}/>
        </ResultFullScreenContainer>
      )}

      resultBottom={(
        <div css={styles.bottomControlBar}>
          <ProcessStatusInfo id="process-status" processStatus={processStatus}/>
          <DataExportControl
            disabled={!outputResult || outputResult instanceof Error}
            data={textInput}

            downloadButtonId={'download-button'}
            downloadFileExt={'.json'}
          />
        </div>
      )}
    />
  )
}

export const isJSONShowable = (value) => {
  try {
    const jsonData = JSON.parse(value)
    return typeof jsonData === 'object' && jsonData !== null
  } catch {
    return false
  }
}
